(() => {
  const validateFields = form => {
    form.querySelectorAll('[data-dl-personalized] [required]').forEach(input => {
      input.setCustomValidity('');
      if (!input.value.trim()) input.setCustomValidity('Completa este dato para personalizar tu pedido.');
    });
  };
  document.addEventListener('input', event => {
    const form = event.target.form;
    if (!form?.querySelector('[data-dl-personalized]')) return;
    validateFields(form);
    const message = form.querySelector('.dl-field-error');
    if (message) message.hidden = form.checkValidity();
  });
  const enforce = () => {
    document.querySelectorAll('form:has([data-dl-personalized])').forEach(form => {
      form.noValidate = false;
      form.querySelectorAll('shopify-accelerated-checkout, .shopify-payment-button').forEach(node => node.hidden = true);
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('button[type="submit"],button[name="add"],input[type="submit"]');
    const form = button?.form || button?.closest('form');
    if (!form?.querySelector('[data-dl-personalized]')) return;
    form.querySelectorAll('[data-dl-personalized] input[type="text"]').forEach(input => input.value = input.value.trim());
    validateFields(form);
    if (!form.checkValidity()) {
      event.preventDefault(); event.stopImmediatePropagation();
      const message = form.querySelector('.dl-field-error'); if (message) message.hidden = false;
      form.reportValidity();
    }
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.querySelector?.('[data-dl-personalized]')) return;
    validateFields(form);
    if (!form.checkValidity()) { event.preventDefault(); event.stopImmediatePropagation(); form.reportValidity(); }
  }, true);
  enforce();
  document.addEventListener('shopify:section:load', enforce);
  const observer = new MutationObserver(enforce); observer.observe(document.body, { childList: true, subtree: true });
})();
